import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
    Avatar,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Button,
    Link,
    Table,
    Grid,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    Select,
    MenuItem,
    TableRow,
    Typography,
    TextField
} from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';

import { get_appointments, get_showrooms } from '../../../../api/API';
import TableEditBar from '../../../../components/TableEditBar/TableEditBar';
import moment from 'moment/moment.js'
import Showroom_Booking from '../Showroom_Booking/Showroom_Booking';
import Reallocate from '../Reallocate/Reallocate';
import CachedIcon from '@material-ui/icons/Cached';
import EditIcon from '@material-ui/icons/Edit';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import DatePicker from 'react-date-picker';
import "./TableList.css";
import { DateRange } from '@material-ui/icons';
// import {enGB} from 'date-fns/locale';
// registerLocale('en-GB', enGB )

const alternated_row_color = "rgb(221 152 21 / 8%)";
const useStyles = makeStyles(theme => ({
    root: {
        // padding: theme.spacing(3)
    },

    content: {
        padding: 0
    },

    inner: {
        minWidth: 700
    },

    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },

    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },

    actions: {
        // padding: theme.spacing(1),
        justifyContent: 'flex-end'
    }

}));
export default class TableList extends React.Component {

    constructor(props) {
        super(props);
        this.color_labeling = ['#cbfff740', 'rgba(139, 195, 74, 0.25)', '#dc747440'];
        this.day_labels = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        this.state = {

            showrooms: [],
            appointments: [],
            show_booking: false,
            reallocate_values: [],
            reallocate_max_appointment: 0,
            reallocate_timeslot_id: 0,
            highlight_slot: '',
            reallocate_timeslot: null,
            view_timeslot: null,
            open_reallocated: false,
            appointment_id: 0,
            values: {
                showroom: 0,
                date: moment(new Date()).format("yyyy-MM-DD")
            }
        }
        // alert(moment(new Date()).format("yyyy-MM-DD"));
    }

    handleChange(e) {
        this.setState({
            ...this.state,
            show_booking: false,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_timetable();
        });

    }

    handleChangeDate(date) {
        // console.log(moment(date).format("yyyy-MM-DD"));
        this.setState({
            ...this.state,
            show_booking: false,
            values: {
                ...this.state.values,
                date: date
            }
        }, () => {
            this.get_timetable();
        });

    }

    async get_timetable() {
        let data = await get_appointments(this.state.values.showroom, moment(this.state.values.date).format("yyyy-MM-DD"));
        if (data) {

            this.setState({
                ...this.state,
                appointments: this.format_data(data)
            });
        }
    }

    format_data(data) {

        console.log(data);
        return data;
    }
    handleCloseModal() {
        this.setState({
            ...this.state,
            open_reallocated: false,
        }, () => {
            this.get_timetable();
        });
    }
    async componentWillMount() {
        this.user_role = window.localStorage.getItem("role");
        let currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms,
                values: {
                    ...currentObj.state.values,
                    showroom: showrooms.length ? showrooms[0]['property_id'] : 0
                }
            }, () => {
                currentObj.get_timetable();
                setInterval(() => {
                    if (currentObj.state.open_reallocated) return;
                    if(currentObj.state.show_booking) return;
                    currentObj.get_timetable();
                }, 10000);
            });
        }

    }
    show_booking(id, timeslot) {
        console.log(timeslot);
        this.setState({
            ...this.state,
            show_booking: true,
            view_timeslot: timeslot,
            appointment_id: id
        });
    }

    closeinfo() {
        this.setState({
            ...this.state,
            show_booking: false
        });
    }
    render() {
        return (
            <React.Fragment>

                <div
                    {...this.props}
                    className={clsx(this.props.classes.root, this.props.className)}
                >
                    <Typography
                        color="textSecondary"
                        gutterBottom
                        variant="body2"
                    >
                        {/* {appointments.length} Records found. Page {page + 1} of{' '}
                        {Math.ceil(appointments.length / rowsPerPage)} */}
                    </Typography>
                    {/* <Grid container spacing={1}>
                        <Grid item md={12}>
                            
                        </Grid>

                    </Grid> */}
                    <Card>
                        <CardHeader
                            //   action={<GenericMoreButton />}
                            title="Appointments"
                        />
                        <Divider />
                        <CardContent className={useStyles.content}>
                       
                                <br></br>
                                <div
                                    className="appointments_filter"
                                >
                                    <Select
                                        
                                        className="appointments_select"
                                        onChange={this.handleChange.bind(this)}
                                        name="showroom"
                                        value={this.state.values.showroom}
                                    >
                                        {
                                            this.state.showrooms.map((showroom) => (
                                                <MenuItem key={showroom.property_id}
                                                    value={showroom.property_id}>
                                                    {showroom.name}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                    <TextField
                                        type="date"
                                        name="date"
                                        className="appointments_date"
                                        onChange={this.handleChange.bind(this)}
                                        value={this.state.values.date}
                                        
                                    >

                                    </TextField>
                                    {/* <DatePicker
                                        value={this.state.values.date}
                                        className={"datepicker"}
                                        onChange={date => this.handleChangeDate(date)}
                                        // onSelect={date => this.handleChangeDate(date)}
                                        name="date"
                                        format="dd/MM/y"
                                    >

                                    </DatePicker> */}
                                </div>
                                {this.state.appointments && (
                                    <div >
                                        <br></br>
                                        {this.state.appointments[0] ?
                                            (
                                                this.state.appointments[0].is_special == "1" ?
                                                    <h3>{this.state.appointments[0].special_title}</h3>
                                                    :
                                                    <h3>{this.day_labels[this.state.appointments[0].day]}</h3>
                                            ) : ''
                                        }
                                        <br></br>
                                        <div className="legend_container">
                                            <label
                                                className="legend_label"
                                                style={{
                                                    marginRight: 20,
                                                    marginBottom: 10
                                                }}
                                            >Legend :</label>
                                            <div
                                                style={{
                                                    display: 'flex'
                                                }}
                                            >
                                                <div style={{
 
                                                    width: 20,
                                                    height: 20, 
                                                    marginRight: 10,
                                                    backgroundColor: "#42a5f5"
                                                }}></div>
                                                <label
                                                    style={{
                                                        marginRight: 20,
                                                    }}
                                                >booked</label>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'flex'
                                                }}
                                            >
                                                <div style={{
                                                    width: 20,
                                                    height: 20,
                                                    marginRight: 10,
                                                    backgroundColor: "#66bb6a"
                                                }}></div>

                                                <label
                                                    style={{
                                                        marginRight: 20,
                                                    }}
                                                >arrived</label>
                                            </div>
                                            <div
                                                style={{
                                                    display: 'flex'
                                                }}
                                            >
                                                <div style={{
                                                    width: 20,
                                                    height: 20,
                                                    marginRight: 10,
                                                    backgroundColor: "#bdbdbd"
                                                }}></div>
                                                <label style={{
                                                    marginRight: 20,
                                                }}
                                                >no show</label>
                                            </div>
                                        </div>
                                        <br /><br />
                                        {this.state.appointments.map(timeslot => (
                                            <React.Fragment key={timeslot.timeslot_id} >
                                                <h2>{moment('2020-02-02 ' + timeslot.start_time).format("h:mm A")} - {moment('2020-02-02 ' + timeslot.end_time).format("h:mm A")}
                                                    <Button style={{
                                                        marginLeft: 20
                                                    }}
                                                        onClick={() => {
                                                            this.setState({
                                                                ...this.state,
                                                                open_reallocated: true,
                                                                reallocate_timeslot: timeslot,
                                                                reallocate_timeslot_id: timeslot.timeslot_id,
                                                                reallocate_max_appointment: timeslot.max_appointment,
                                                                reallocate_values: timeslot.agencies
                                                            });
                                                        }}
                                                        variant="contained"
                                                    ><EditIcon></EditIcon></Button>
                                                </h2>
                                                <br></br>
                                                <Grid container className="agency_card_container">
                                                    {timeslot.type == "1" ?
                                                        (
                                                            <React.Fragment>
                                                                {timeslot.agencies.map((agency) => (
                                                                    <div className="agency_wrapper">
                                                                        <div className="agency">
                                                                            {agency.name}
                                                                            <p className="leftover">{agency.max_appointment - agency.bookings.length} available</p>
                                                                        </div>
                                                                        <div className="agency_booking_wrapper">
                                                                            {agency.bookings.map((booking) => (
                                                                                <div className="agency_booking"
                                                                                    onClick={((e) => {
                                                                                        this.setState({
                                                                                            ...this.state
                                                                                        }, () => {
                                                                                            this.show_booking(booking.appointment_id, timeslot);
                                                                                        });

                                                                                    }).bind(this)}
                                                                                >
                                                                                    <div className={"status_icon " + "status_" + booking.status}></div>
                                                                                    <p>{booking.agent_name}</p>
                                                                                    <p>{booking.agent_contact}</p>
                                                                                    <p className="pax">Agents: {booking.agent_pax} <span className="hidden_mobile"> </span> Guests: {booking.pax}</p>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </React.Fragment>
                                                        )
                                                        : (
                                                            <React.Fragment>

                                                                <div className="agency_wrapper">
                                                                    <div className="agency">
                                                                        FCFS
                                                                        <p className="leftover">{timeslot.fcfs_appointment - timeslot.bookings.length} available</p>
                                                                    </div>
                                                                    <div className="agency_booking_wrapper">

                                                                        {timeslot.bookings.map((booking) => (
                                                                            <div className="agency_booking"
                                                                                onClick={((e) => {
                                                                                    this.setState({
                                                                                        ...this.state
                                                                                    }, () => {
                                                                                        this.show_booking(booking.appointment_id, timeslot);
                                                                                    });

                                                                                }).bind(this)}
                                                                            >
                                                                                <div className={"status_icon " + "status_" + booking.status}></div>
                                                                                <p>{booking.agent_name}</p>
                                                                                <p>{booking.agent_contact}</p>
                                                                                <p className="pax">Agents: {booking.agent_pax} <span className="hidden_mobile"> </span> Guests: {booking.pax}</p>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </React.Fragment>
                                                        )}

                                                </Grid>
                                                <br></br>
                                                <hr></hr>
                                                <br></br>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                )}

                            
                        </CardContent>

                    </Card>

                </div >
                {
                    this.state.show_booking && (
                        <Showroom_Booking

                            open={this.state.show_booking}
                            closeaction={this.closeinfo.bind(this)}
                            date={this.state.values.date}
                            timeslot={this.state.view_timeslot}
                            appointment_id={this.state.appointment_id}
                            classes={this.props.classes}></Showroom_Booking>
                    )}
                {this.state.open_reallocated && (
                    <Reallocate

                        timeslot_id={this.state.reallocate_timeslot.timeslot_id}
                        date={this.state.values.date}
                        onClose={this.handleCloseModal.bind(this)}
                        agencies={this.state.reallocate_values}
                        open={this.state.open_reallocated}
                        max_appointment={this.state.reallocate_max_appointment}
                    ></Reallocate>
                )}

            </React.Fragment>
        );

    }


}